export default __webpack_public_path__ + "static/media/token-icon-1.7345b044.svg";